export default function(target) {
    for (let i = 1; i < arguments.length; i++) {
        let source = arguments[i] || {};
        for (let prop in source) {
            if (typeof source !== 'object') {
                throw 'invalid type error';
            }
            if (Object.prototype.hasOwnProperty.call(source, prop)) {
                let value = source[prop];
                if (value !== undefined) {
                    target[prop] = value;
                }
            }
        }
    }

    return target;
}
